<template>
  <div class="grid-main bg-purple " >
  <h2 style="float: left">用户列表</h2>
  <el-button type="primary" @click="addUser">添加用户</el-button>


  <div class="table-box" >

    <el-table
      :data="userList.list"
      height="550"
      border
      style="width: 100%;">

      <el-table-column
        prop="userName"
        label="用户名"
      >
      </el-table-column>
      <el-table-column

        label="头像">
        <template slot-scope="scope">
          <img :src="scope.row.avatar" alt="" style="width: 64px;
                                       height: 64px;
                                       border: 2px solid #FFFFFF;
                                       border-radius: 50%;"/>
        </template>
      </el-table-column>
      <el-table-column
        label="有效期">
        <template slot-scope="scope">
          {{scope.row.periodStart | myFuncton}}-{{scope.row.periodEnd | myFuncton}}
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        fixed="right"
        >
        <template slot-scope="scope">
          <el-button
          	type="success"
            size="mini"
            @click="openuser(scope.row.id)">编辑</el-button>
          <el-button
            v-if="scope.row.id>1"
            size="mini"
            type="danger"
            @click="openDelete(scope.row.id)">删除</el-button>
          <el-button
            type="success"
            size="mini"
            @click="openuserrole(scope.row.id)">分配角色</el-button>
          <!-- <el-button
          type="success"
          v-if="scope.row.id>1"
          size="mini"
           @click="openoperatorUser(scope.row.id)">分配企业</el-button> -->


        </template>
      </el-table-column>

    </el-table>
    <el-pagination
    	v-if="userList.userListtotal>10"
      background
      layout="prev, pager, next"
      :page-size="userList.userListpageSize"
      @current-change="setUserList"
      :total="userList.userListtotal">

    </el-pagination>



  <!--修改用户分配角色-->
  <el-dialog  :visible.sync="dialoguserroleId" width="30%" :before-close="dialoguserclose">
    <el-form ref="form"  label-width="130px">
      <el-form-item label="选择角色：">
        <el-select v-model="AlluserRolevalue" placeholder="请选择">
          <el-option
            v-for="item in AlluserRole"
            :key="item.id"
            :label="item.roleName"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="setuserRole()">确认提交</el-button>

      </el-form-item>
    </el-form>
  </el-dialog>




  <!--修改用户列表用户头像-->
  <el-dialog  :visible.sync="dialogupdatauser" :before-close="dialoguserclose">
    <el-form ref="form" :model="form" label-width="150px">
      <el-form-item label="头像：">
        <el-upload
          class="avatar-uploader"
          :action="afileUrl"
          name="files"
          :show-file-list="false"
          :on-success="handleimgSuccess"
          :before-upload="beforeAvatarUpload">
          <img v-if="fileimg" :src="fileimg" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="手机号：">
        <el-input v-model="phoness" type="text" placeholder="手机号" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item >
        <el-button type="primary" @click="userupdate()" style="float: left;">确认提交</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>




  <el-dialog  :visible.sync="dialogFormVisible" :before-close="dialoguserclose">
    <el-form ref="form" label-width="150px">
      <el-form-item label="头像：">
        <el-upload
          class="avatar-uploader"
          :action="afileUrl"
          name="files"
          :show-file-list="false"
          :on-success="handleimgSuccess"
          :before-upload="beforeAvatarUpload">
          <img v-if="fileimg" :src="fileimg" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="用户名：">
        <el-input v-model="form.name" placeholder="用户名"></el-input>
      </el-form-item>
      <el-form-item label="手机号：">
        <el-input v-model="form.phone" type="text" placeholder="手机号" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="密码：">
        <el-input v-model="form.pwd" type="password" placeholder="密码" autocomplete="new-password"></el-input>
      </el-form-item>
      <el-form-item label="确认密码：">
        <el-input v-model="form.spwd" type="password" placeholder="确认密码" autocomplete="new-password"></el-input>
      </el-form-item>
      <el-form-item label="用户有效期：">
        <el-col :span="11">
          <el-date-picker type="date" placeholder="开始日期"  format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd HH:mm:ss" v-model="form.date1" style="width: 100%;"></el-date-picker>
        </el-col>
        <el-col class="line" :span="2">-</el-col>
        <el-col :span="11">
          <el-date-picker ype="date" placeholder="结束日期"  format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd HH:mm:ss"   v-model="form.date2" style="width: 100%;"></el-date-picker>
        </el-col>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">确认提交</el-button>

      </el-form-item>
    </el-form>
  </el-dialog>



  </div>
  </div>
</template>

<script>
export default {
  name: "Manager",
  data(){
    return {
      userList:{
        list:[],
        userListpage:1,
        userListtotal:0,
        userListpageSize:10,
      },
      form: {
        avatar:'',
        name: '',
        phone:'',
        pwd: '',
        spwd: '',
        date1: '',
        date2: '',
      },
      dialoguserroleId:false,
      userroleId:'',
      AlluserRole:{},
      AlluserRolevalue:'',
      //分配用户
      dialogoperatorUser:false,

      //所有企业
      AllOperator:{},
      AllOperatorvalue:'',

      dialogupdatauser:false,
      afileUrl:'/api/upload/imgs',

      fileimg:'',

      //用户列表
      phoness:'',

      dialogFormVisible: false,

      //dialogupdataVisible:false,

      circleUrl:'',
    }
  },
  beforeRouteEnter(to,from,next){

    next((vm)=>{

    });
  },
  created(){

  },
  mounted () {
   this.etUserList();
  },
  methods: {
  	addUser(){
  		this.dialogFormVisible=true
      window.setTimeout(() => {
	      this.form.phone=""
	      this.form.pwd=""
      },100);
  	},
    dialoguserclose(){
      this.dialogFormVisible=false;
      this.dialogupdatauser=false;
      this.dialoguserroleId=false;
      this.fileimg='';
      this.AlluserRolevalue='';
      this.phoness='';
      this.form ={
        avatar:'',
        name: '',
        phone:'',
        pwd: '',
        spwd: '',
        date1: '',
        date2: '',
      };
    },

    //通用上传
    handleimgSuccess(res, file) {
      let that = this;

      if(res.data.errno==0){
        that.fileimg = res.data.data[0];
      }else{
        that.$message.error('上传失败');
      }
    },
    //上传头像
    handleAvatarSuccess(res, file) {
      let that = this;

      if(res.data.errno==0){
        that.scoreItemUrl = res.data.url;
        that.fileName = res.data.fileName;
        that.userupdate(res.data.data[0])
      }else{
        that.$message.error('上传失败');
      }
    },
    //限制图片大小
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG、JPEG、PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
    //用户列表
    etUserList(){
      let that = this;
      let userdata = {
        page:this.userList.userListpage,
        pageSize:this.userList.userListpageSize,
      }
      this.$axios.defaults.withCredentials=true;
      this.$axios
        .post('/api/user/getUserList',userdata)
        .then(function (res) {
          if(res.data.code==200){
            that.userList.list = res.data.data.list;
            that.userList.userListtotal = res.data.data.total;
          }
          else{
            that.$message.error(res.data.msg);
          }
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },
    setUserList(userListpage){
      this.userList.userListpage = userListpage;
      this.etUserList();
    },

    //新增用户
    onSubmit() {
      let that = this;
      that.form.avatar = that.fileimg;

      if (that.form.avatar == '') {
        that.$message.error("请上传头像");
        return false;
      }

      if (that.form.name == '') {
        that.$message.error("请输入用户名");
        return false;
      }
      if (that.form.phone == '') {
        that.$message.error("请输入手机号");
        return false;
      }
      var reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if (!reg_tel.test(that.form.phone)) {
        that.$message.error("请输入正确的手机号");
        return false;
      }
      if (that.form.pwd == '') {

        that.$message.error("请输入密码");
        return false;
      }
      if (that.form.spwd == '') {
        that.$message.error("请输入确认密码");
        return false;
      }

      if (that.form.pwd != that.form.spwd) {
        that.$message.error("账号密码不一致");
        return false;
      }
      if (that.form.date1 == '') {
        that.$message.error("请输入有效期开始日期");
        return false;
      }

      if (that.form.date2 == '') {
        that.$message.error("请输入有效期结束日期");
        return false;
      }


      let formdata = {
        avatar:that.form.avatar,
        userName:that.form.name,
        phone:that.form.phone,
        passWord:that.form.pwd,
        confirmPassword:that.form.spwd,
        periodStart:that.form.date1,
        periodEnd:that.form.date2
      }
      this.$axios
        .post('/api/user/userAdd', formdata)
        .then(function (res) {
          if (res.data.code == 500) {
            that.$message.error("账号添加失败:"+res.data.msg);
            return false;
          } else if (res.data.code == 200) {
            that.$message({
              message: '账号添加成功',
              type: 'success'
            });
            window.setTimeout(() => {
              location.reload();
            }, 1000);

          }
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },

    //编辑用户
    selectSysUserById(){
      let that = this;
      let ueerids ={
        id : this.userId,
      }

      this.$axios.defaults.withCredentials=true;
      this.$axios
        .post('/api/user/selectSysUserById',ueerids)
        .then(function (res) {

          that.fileimg=res.data.data.avatar;
          that.phoness=res.data.data.phone


        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });

    },

    openuser(userId){
      this.userId = userId;


      this.selectSysUserById();

      window.setTimeout(() => {
        this.dialogupdatauser = true;
      },100);

    },

    //修改用户列表用户
    userupdate(){
      let that = this;


      if (that.fileimg  == '') {
        that.$message.error("请上传头像");
        return false;
      }
      if (that.phoness == '') {
        that.$message.error("请输入手机号");
        return false;
      }
      var reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if (!reg_tel.test(that.phoness)) {
        that.$message.error("请输入正确的手机号");
        return false;
      }
      let ueers ={
        avatar:this.fileimg,
        userId:this.userId,
        phone:this.phoness
      }

      this.$axios.defaults.withCredentials=true;
      this.$axios
        .post('/api/user/update',ueers)
        .then(function (res) {
          if(res.data.code==200){
            that.$message({
              message: '保存成功',
              type: 'success'
            });
            window.setTimeout(() => {
              location.reload();
            }, 1000);
          }else{
            that.$message.error(
              '保存失败'
            );
          }

        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },


    getUserRole(){
      let that = this;
      let UserRoledata = {
        userId:this.userroleId
      }
      this.$axios
        .post('/api/user/getUserRole',UserRoledata)
        .then(function (res) {
          that.AlluserRolevalue = res.data.data.roleId;
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },
    //分配角色
    openuserrole(userroleId){

      this.selectAlluserRole();
      this.userroleId = userroleId;
      this.getUserRole();

      window.setTimeout(() => {
        this.dialoguserroleId = true;
      },100);

    },

    //获取全部角色
    selectAlluserRole(){
      let that = this;
      this.$axios
        .get('/api/role/getAllRole')
        .then(function (res) {
          if(res.data.code == 200){
            that.AlluserRole = res.data.data;
          }

        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },
    //修改角色
    setuserRole(){
      let that = this;
      let userRoledata = {
        userId:that.userroleId,
        roles:[],
      }
      userRoledata.roles.push(that.AlluserRolevalue);
      this.$axios
        .post('/api/user/userRole',userRoledata)
        .then(function (res) {
          if(res.data.code==200){
            that.$message({
              message: '分配成功',
              type: 'success'
            });
            window.setTimeout(() => {
              location.reload();
            }, 1000);
          }else{
            that.$message.error(res.data.msg);
          }
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },

    openDelete(userId) {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this. userbatchDelete(userId);
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    //删除用户
    userbatchDelete(userId){
      let that = this;
      let userIdas = {
        userIds:[]
      }
      userIdas.userIds.push(userId);
      this.$axios
        .post('/api/user/batchDelete',userIdas)
        .then(function (res) {

          if(res.data.code==200){
            that.$message({
              message: '删除成功',
              type: 'success'
            });
            window.setTimeout(() => {
              location.reload();
            }, 1000);
          }
          else{
            that.$message.error(res.data.msg);
          }
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },


  },
  filters:{ //钩子
    myFuncton(date_time){

      //去掉日期数据中的T 和Z
      //by XiaoMa
      if (date_time !=null){

        let date=new Date(+new Date(date_time) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '');
        return date
      }else {
        return date_time
      }

    },


  },
  watch: {

  },
}

</script>

<style scoped>
/deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  float: left;
}
/deep/ .el-upload:hover {
  border-color: #409EFF;
}
/deep/ .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 60px;
  height: 60px;
  line-height: 60px;
  text-align: center;
}
/deep/ .avatar {
  width: 60px;
  height: 60px;
  display: block;
}
.el-col-2{line-height: 40px}
</style>



// WEBPACK FOOTER //
// src/view/admin/Manager.vue